/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 * Widget types
 *
 * @author Fedorov Maxim
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.11.0
 * @since 1.0.1
 */

export enum EFormatData {
    FullData = 'DD.MM.YYYY',
    FullDataShortYear = 'DD.MM.YY',
    FullDataOnlyDay = 'DD',
    FullDataOnlyMonth = 'MM',
    FullDataOnlyYear = 'YY',
    FullDataWithTimeZone = 'YYYY-MM-DDTHH:mm:ss.SSSSZ',
    FullDateWithFullTime = 'DD.MM.YYYY HH:mm:ss',
    FullDateWithTime= 'DD.MM.YYYY HH:mm',
    FullTime = 'HH:mm:ss',
    OnlyHourMinutes = 'HH:mm',
    OnlyDay = 'D',
    OnlyDayFull = 'DD',
    OnlyHour = 'HH',
    OnlyMinutes = 'mm',
    OnlyMonth = 'M',
    OnlyMonthFull = 'MM',
    OnlyYear = 'Y',
    OnlyYearFull = 'YYYY',
    ReverseData = 'YYYY-MM-DD',
    YearMonthReverse = 'YYYY-MM',
}
